export class GetDeveloperPortalResources {
	static readonly type: string = '[DeveloperResources] GetDeveloperPortalResources';
}

export class ClearDeveloperPortalResourcesState {
	static readonly type: string = '[DeveloperResources] ClearDeveloperPortalResourcesState';
}
